import { useState, useCallback } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { CalculatorSection } from "./components/CalculatorSection";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { IndustriesSection } from "./components/IndustriesSection";
import { ClienteleSection } from "./components/ClienteleSection";
import { BrandsSection } from "./components/BrandsSection";
import { ProcessSection } from "./components/ProcessSection";
import { FAQSection } from "./components/FAQSection";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { AdminDashboard } from "./components/AdminDashboard";

const LandingPage = () => {
  const [calcData, setCalcData] = useState(null);

  const handleGetQuote = useCallback((data) => {
    setCalcData(data);
    // Scroll to CTA form
    setTimeout(() => {
      const el = document.getElementById("cta");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <CalculatorSection onGetQuote={handleGetQuote} />
      <WhyChooseUs />
      <IndustriesSection />
      <ClienteleSection />
      <BrandsSection />
      <ProcessSection />
      <FAQSection />
      <CTASection calcData={calcData} />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
